<template>
  <div class="project-status">
    <el-dialog
      title="查看项目流程状态"
      :visible.sync="statusDialog"
      top="29vh"
      width="500px"
      :lock-scroll="false"
      :close-on-click-modal="false"
      @close="closeDialog"
    >
      <div class="project-status__wrapper">
        <el-scrollbar>
          <ul class="project-status__list">
            <li v-for="(item, index) in projectList" :key="index">
              <h4>{{ item.lastUpdateTime }}</h4>
              <p>
                <span>【{{ item.dockingStatusName }}】</span>
                <span>{{ item.description }}</span>
                <a
                  v-for="(file, i) in item.attList"
                  :key="i"
                  :href="file.url"
                  :download="file.name"
                  target="_blank"
                  >{{ file.name }}</a
                >
              </p>
            </li>
          </ul>
        </el-scrollbar>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    projectList: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      statusDialog: true
    };
  },
  methods: {
    // 关闭弹框后回调
    closeDialog() {
      // 传递关闭上一级
      this.$emit("close", true);
      // this.$emit("complete", true);
    }
  }
};
</script>

<style lang="less" scoped>
.project-status {
  /deep/ .el-dialog__body {
    padding: 20px;
  }
  &__wrapper {
    height: 240px;
  }
  &__list {
    margin: 0 30px;
    li {
      padding: 10px 20px 9px;
      line-height: 20px;
      border-bottom: 1px solid #e6e6e6;
      &:first-child {
        padding-top: 0;
      }
      h4 {
        position: relative;
        font-weight: normal;
        &::before {
          content: "";
          left: -24px;
          top: 6px;
          position: absolute;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: @mainColor;
        }
      }
      p {
        a {
          padding-left: 10px;
          color: #0080ff;
        }
      }
    }
  }
}
</style>
